import React from 'react'
import { string, bool, oneOfType, element } from 'prop-types'
import classNames from 'src/common/helpers/class-names'

import Link from 'src/common/components/link'

const blk = 'co-product-list'

export const ViewAllLink = ({ show }) => {
  if (!show) return null
  return <Link href="/" className={`${blk}__anchor`}>View All</Link>
}

ViewAllLink.propTypes = { show: bool }
ViewAllLink.defaultProps = { show: false }

const Header = ({ title, showAllAction, mix }) => {
  if (!title) return null
  return (
    <div className={classNames({ blk, elt: 'header', mix })}>
      <h3 className={classNames({ blk, elt: 'title', mix })}>
        {title}
      </h3>
      <ViewAllLink mix={mix} show={showAllAction} />
    </div>
  )
}

Header.propTypes = {
  title: oneOfType([
    string,
    element,
  ]),
  showAllAction: bool,
  mix: string,
}

Header.defaultProps = {
  title: '',
  showAllAction: false,
  mix: '',
}

export default Header



// WEBPACK FOOTER //
// ./shared/interim/product-list/header.js